import React, { Fragment } from 'react'
import _ from 'lodash'
import { sanitizeTrackPoints } from 'lib/routeUtils'
import { Polyline } from 'common/Map/Polyline'
import { Marker } from 'common/Map/Marker'
import { DistanceMarkers } from 'common/Map/DistanceMarkers'
import p from 'prop-types'
import { trackPoints } from 'lib/propTypes'

// const DEFAULT_COLOR = 16711680
const DEFAULT_COLOR_CSS = '#FF0000'
const EXCLUDED_POINT_COLOR = '#A0A0A0'

const hashForPolyline = (route, slice) => slice
  ? `${route.id}:${slice[0]}:${slice[1]}`
  : '' + route.id

const splitOnColor = _.memoize((route, slice, sanitizedPoints) => {
  let lineSegments = []
  let currentSegment = []
  let currentColor = sanitizedPoints[0] ? sanitizedPoints[0].color : undefined
  let excludeSegment = false

  // do it backwards, because it makes more sense that way
  // full explanation: https://goo.gl/h8sAbx
  for (let i = sanitizedPoints.length - 1; i >= 0; i--) {
    const point = sanitizedPoints[i]
    currentSegment.push(point)
    if (point.excludeFromMetrics && !excludeSegment) {
      lineSegments.push(currentSegment)
      currentSegment = [point]
      excludeSegment = true
      continue
    }

    if (excludeSegment && !point.excludeFromMetrics) {
      lineSegments.push(currentSegment)
      point.color && (currentColor = point.color)
      currentSegment = [{ ...point, color: currentColor }]
      excludeSegment = false
      continue
    }

    if (point.color !== null) {
      if (point.color !== currentColor) {
        lineSegments.push(currentSegment)
        currentSegment = [point] // include point in next segment to prevent overlap
      }
      currentColor = point.color
    }
  }
  // clear last segment
  currentSegment.length > 0 && lineSegments.push(currentSegment)
  lineSegments.reverse() // crappy inplace API
  return lineSegments
}, hashForPolyline)

const getColorForSegment = s => {
  if (s[0].excludeFromMetrics) {
    return EXCLUDED_POINT_COLOR
  }
  return Number.isFinite(s[0].color)
    ? cssColor(s[0].color)
    : DEFAULT_COLOR_CSS
}

const cssColor = (int) => {
  var color = int < 0 ? '0' : int.toString(16)
  while (color.length < 6) color = '0' + color
  return '#' + color.toUpperCase()
}

export class RouteLine extends React.PureComponent {
  static defaultProps = {
    color: null,
    showStartMarker: true,
    showEndMarker: true,
    showDistanceMarkers: false,
    weight: 3
  }

  static propTypes = {
    route: p.shape({
      trackPoints: trackPoints
    })
  }

  render () {
    const { route, color, weight, slice, showStartMarker, showEndMarker, showDistanceMarkers } = this.props

    const points = sanitizeTrackPoints(route, slice)
    // todo skip this step for trips (no color data)
    // skip color step if we're forcing a specific color for the whole line
    const segments = color ? [points] : splitOnColor(route, slice, points)
    return (
      <Fragment>
        {segments.map((s, i) =>
          <Polyline
            key={s[0].color + '-' + i}
            color={color || getColorForSegment(s)}
            weight={weight}
            positions={s} />)}
        {showDistanceMarkers && <DistanceMarkers trackPoints={points} />}
        {showStartMarker && <Marker icon='start' position={points[0]} />}
        {showEndMarker && <Marker icon='stop' position={points[points.length - 1]} />}
      </Fragment>
    )
  }
}
